<template>
  <div id="app">
    <top></top>
    <router-view :key="$route.fullPath" />
    <foot></foot>
  </div>
</template>

<script>
import "./assets/css/com.css";
import top from "@/components/top";
import foot from "@/components/foot";
export default {
  name: "App",
  components: {
    top,
    foot
  },
  created() {
    this.$root.showTips = this.showTips;
    window.addEventListener("resize", this.resizeFun, false);
  },
  methods: {
    showTips(content, message, height, time) {
      let docTips = document.getElementById("tips");
      docTips.innerHTML =
        '<div class="tipsClass ' + message + '"><i></i>' + content + "</div>";
      this._resize < 750
        ? (height = height / 100 + "rem")
        : (height = height + "rem");
      docTips.children[0].style.top = height;
      docTips.children[0].style.display = "block";
      setTimeout(function() {
        docTips.children[0].style.display = "none";
      }, time * 1000);
    }
  }
};
</script>
<style>
#app {
  height: 100%;
  overflow: hidden;
}
.tipsClass {
  text-align: left;
  width: 5.5rem;
  margin: 0 auto;
}
.tipsClass.ok {
  background: #f0f9eb;
  color: #67c23a;
  font-weight: bold;
}
.tipsClass > i {
  position: relative;
  margin-right: 0.3rem;
  line-height: 1;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
  font-size: 0.14rem;
  font: normal normal normal 0.14rem/1 FontAwesome;
  text-rendering: auto;
}
.tipsClass.ok > i:before {
  content: "✔";
  color: #fff;
  display: block;
}
.tipsClass.ok > i:after {
  display: block;
  position: absolute;
  content: "";
  width: 0.2rem;
  height: 0.2rem;
  line-height: 0.2rem;
  background: #67c23a;
  left: -0.05rem;
  top: -0.03rem;
  border-radius: 50%;
  text-align: center;
  z-index: -1;
}
.tipsClass.err {
  border-color: #fde2e2;
  background-color: #fef0f0;
  font-weight: bold;
  color: #f56c6c;
}
.tipsClass.err > i:before {
  content: "×";
  color: #fff;
  display: block;
}
.tipsClass.err > i:after {
  display: block;
  position: absolute;
  content: "";
  width: 0.2rem;
  height: 0.2rem;
  line-height: 0.2rem;
  background: #f56c6c;
  left: -0.05rem;
  top: -0.03rem;
  border-radius: 50%;
  text-align: center;
  z-index: -1;
}
.tipsClass.warn {
  border-color: #faecd8;
  background-color: #fdf6ec;
  color: #e6a23c;
}
.tipsClass.warn > i:before {
  content: "!";
  color: #fff;
  font-weight: bold;
  display: block;
}
.tipsClass.warn > i:after {
  display: block;
  position: absolute;
  content: "";
  width: 0.2rem;
  height: 0.2rem;
  line-height: 0.2rem;
  background: #e6a23c;
  left: -0.08rem;
  top: -0.03rem;
  border-radius: 50%;
  text-align: center;
  z-index: -1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue